import React from 'react';
import ContentSplit from './contentSplit';
import * as SC from './dinner.styled';
import { Checkbox, CheckboxGroup, CheckboxLabel, H2, HTML, Label, Section, Select, Text, Link, H3, Button, FormButton, Form, PayPalButton } from '../common';
import img from '../images/cartoon-pink.png';
import { openInNewTab } from './paypalForm';

interface DinnerProps {
  isFriendsArea?: boolean;
}

const PRICE_TWO_COURSE = 29.50;
const PRICE_THREE_COURSE = 37.00;
const PRICE_BREAD = 4;
const PRICE_CHEESE = 9;

const DINNER_TWO_COURSE_BREAD_CHEESE = 'VH8ZALX58KCBU';
const DINNER_TWO_COURSE_CHEESE = 'RMBVH9A355XDG';
const DINNER_TWO_COURSE_BREAD = '24F7B6Z9TXUZQ';
const DINNER_TWO_COURSE = 'Q2QQFYT7YPKBG';
const DINNER_THREE_COURSE_BREAD_CHEESE = 'BGGY6YKBX27FE';
const DINNER_THREE_COURSE_CHEESE = 'XCVCS85AQT54N';
const DINNER_THREE_COURSE_BREAD = 'U92HR9BESNPS2';
const DINNER_THREE_COURSE = '9WHN7WTZYESKW';

const isNearDeadline = () => {
  const now = new Date();
  const ukNow = new Date(now.toLocaleString('en-GB', { timeZone: 'Europe/London' }));
  const target = new Date('2026-01-01T00:00:00');
  
  return ukNow > target;
};

// const isBeyondDeadline = () => {
//   const now = new Date();
//   const ukNow = new Date(now.toLocaleString('en-GB', { timeZone: 'Europe/London' }));
//   const target = new Date('2026-02-14T00:00:00');

//   return ukNow > target;
// };

// For Testing
// const isNearDeadline = () => true;
const isBeyondDeadline = true;

const DinnerContents: React.FC<DinnerProps> = (props) => {
    const { isFriendsArea } = props;
    const [courses, setCourses] = React.useState<string | undefined>(undefined);
    const [extrasCheese, setExtrasCheese] = React.useState(false);
    const [extrasBread, setExtrasBread] = React.useState(false);

    const getButtonId = () => {
      if (courses === 'two') {
        if (extrasCheese && extrasBread) {
          return DINNER_TWO_COURSE_BREAD_CHEESE
        }

        if (extrasCheese) {
          return DINNER_TWO_COURSE_CHEESE
        }

        if (extrasBread) {
          return DINNER_TWO_COURSE_BREAD
        }

        return DINNER_TWO_COURSE
      } else {
        if (extrasCheese && extrasBread) {
          return DINNER_THREE_COURSE_BREAD_CHEESE;
        }

        if (extrasCheese) {
          return DINNER_THREE_COURSE_CHEESE
        }

        if (extrasBread) {
          return DINNER_THREE_COURSE_BREAD
        }

        return DINNER_THREE_COURSE
      }
    }

  const getTotal = () => {
    let total = courses === 'two' ? PRICE_TWO_COURSE : PRICE_THREE_COURSE;
    total += extrasCheese ? PRICE_CHEESE : 0;
    total += extrasBread ? PRICE_BREAD : 0;
    return total.toFixed(2); 
  }
      
    return (
        <ContentSplit
          theme="pink"
          warning="The deadline for choosing your dinner courses has now expired."
          rightContent={
            <>
              <H2>Annual Dinner 2026</H2>
              <HTML>
                <Text>If you're planning to attend our Annual Dinner on Saturday 7 March 2026 in Straford-Upon-Avon, here's how you book your place at the table. For information concerning travel, accomodation and a schedule for the Annual General Meeting, please see the AGM section {isFriendsArea ? 'below this module' : `within The Friends' Area`}.</Text>
                <H3>1. Place your Order</H3>
                  <Text>
                    The deadline for choosing your dinner courses has now expired. You can still pay for any order placed, using the form below.
                  </Text>
                  {/* <Text>
                    <SC.Hyper to="https://forms.gle/MFQ12dteCQhoNLGr6" target='_blank'>Use this form</SC.Hyper> to choose your courses.
                    <br />Then return to this page afterwards.
                  </Text> */}
                {/* )}                 */}
                <H3>2. Pay for your Dinner</H3>
                <Section>
                  <Select
                    value={courses}
                    id="courses-select"
                    onChange={(e) => setCourses(e.target.value)}
                  >
                    <option key='undefined' value={undefined}>
                        Please select your courses
                    </option>
                    <option key='two' value='two'>
                        Two Course Dinner (£{PRICE_TWO_COURSE.toFixed(2)})
                    </option>
                    <option key='three' value='three'>
                        Three Course Dinner (£{PRICE_THREE_COURSE.toFixed()})
                    </option>
                  </Select>
                  {courses && (
                    <SC.Group>
                      <Label>Any additional items?</Label>

                      <CheckboxGroup>
                        <Checkbox
                          type="checkbox"
                          id="extra-bread"
                          name="bread"
                          checked={extrasBread}
                          onChange={(e) => setExtrasBread(e.target.checked)}
                        />
                        <CheckboxLabel htmlFor="extra-bread">
                          Bread & Butter with starter (£{PRICE_BREAD})
                        </CheckboxLabel>
                      </CheckboxGroup>

                      <CheckboxGroup>
                        <Checkbox
                          type="checkbox"
                          id="extra-cheese"
                          name="cheese"
                          checked={extrasCheese}
                          onChange={(e) => setExtrasCheese(e.target.checked)}
                        />
                        <CheckboxLabel htmlFor="extra-cheese">
                          Cheeseboard (£{PRICE_CHEESE})
                        </CheckboxLabel>
                      </CheckboxGroup>
                    </SC.Group>
                  )}
                  {courses && (
                    <SC.Basket>
                      <H3>Your order comes to £{getTotal()}</H3>
                      <Form
                          action={`https://www.paypal.com/ncp/payment/${getButtonId()}`}
                          method="post"
                          target="_blank"
                          onSubmit={openInNewTab}
                      >
                          <PayPalButton
                              type="image"
                              src='https://www.paypalobjects.com/en_US/GB/i/btn/btn_donateCC_LG.gif'
                              name="submit"
                              title="PayPal - The safer, easier way to pay online!"
                              alt='Buy Now'
                          />
                      </Form>
                    </SC.Basket>
                  )}
                </Section>
              </HTML>
            </>
          }
          leftImage={img}
          imagePosition="top center"
        />
    )
}

export default DinnerContents;